import React from "react";
import {
  Flex,
  Divider,
  Box,
  Image,
  HStack,
  Center,
  Grid,
  GridItem,
  Link,
} from "@chakra-ui/react";
import logo from "../images/logo.png";

const Footer = () => {
  const data = [
    { title: "Product", extras: [{ text: "Home", link: "/app/getplan" }] },
    {
      title: "Resources",
      extras: [
        { text: "Docs", link: "https://chainpulse.gitbook.io/chainpulse/" },
        {
          text: "Whitepaper",
          link: "https://docsend.com/view/y38iy6chjr4y5b8a",
        },
        {
          text: "$CP",
          link: "https://solscan.io/token/6VXq8brmqKJ2whzpmPypMvrzitgmYYE3bvjrVdXsYLCR",
        },
      ],
    },
    {
      title: "Socials",
      move: true,
      extras: [
        { text: "Twitter", link: "https://twitter.com/ChainPulseSOL/" },
        { text: "Telegram", link: "https://t.me/chainpulseapp" },
      ],
    },
    /*   {
      title: "Legal",
      move: true,
         extras: [
        { text: "Privacy Policy", link: "" },
        { text: "Terms of Service", link: "/tos" },
        { text: "Mandatory Disclaimer", link: "/disclaimer" },
      ],
    }, */
  ];
  return (
    <div>
      <Center>
        <Divider
          w={{ base: "90%", md: "90%" }}
          mt={{ base: "200px", md: "300px" }}
          mb="20px"
        />
      </Center>

      <Flex
        w="100%"
        p="50px"
        alignItems={{ base: "flex-start", md: "center" }}
        justifyContent="space-between"
        flexDir={{ base: "column", md: "row" }}
      >
        <Box w={{ base: "50%", md: "40%" }}>
          <HStack>
            <Image boxSize="40px" src={logo} />
            <Box fontSize="20px">ChainPulse</Box>
          </HStack>
        </Box>
        <Box w={{ base: "50%", md: "60%" }} mt={{ base: "40px", md: "0px" }}>
          <Grid
            gap={{ base: "130px", md: "30px" }}
            templateRows={{ base: "repeat(2,1fr)", md: "repeat(1, 1fr)" }}
            templateColumns={{ base: "repeat(2,1fr)", md: "repeat(3,1fr)" }}
          >
            {data?.map((e, i) => {
              return (
                <>
                  <GridItem>
                    <Flex
                      mt={{ base: e?.move ? "-80px" : "0px", md: "0px" }}
                      fontSize="14px"
                      alignItems="flex-start"
                      justifyContent="center"
                      flexDir="column"
                    >
                      <Box>{e?.title}</Box>
                      {e?.extras?.map((e, i) => {
                        return (
                          <>
                            <Link
                              _hover={{ textDecoration: "none" }}
                              href={e?.link}
                            >
                              <Box
                                _hover={{ color: "#22e9a0" }}
                                color="gray.500"
                                mt="30px"
                              >
                                {e?.text}
                              </Box>
                            </Link>
                          </>
                        );
                      })}
                    </Flex>
                  </GridItem>
                </>
              );
            })}
          </Grid>
        </Box>
      </Flex>
      <Center>
        <Divider w={{ base: "90%", md: "90%" }} mt="20px" mb="30px" />
      </Center>

      <Flex
        p="50px"
        fontSize="14px"
        w="100%"
        alignItems="center"
        justifyContent="space-between"
        color="gray.500"
        flexDir={{ base: "column", md: "row" }}
      >
        <Box>© 2024 ChainPulse. All rights reserved.</Box>
        <Box mt={{ base: "20px", md: "0px" }}>
          <HStack>
            <Flex
              flexDir="column"
              alignItems="flex-start"
              justifyContent="flex-start"
            >
              <Box>
                <HStack>
                  <Image boxSize="20px" src={logo} />
                  <Box color="white">ChainPulse</Box>
                </HStack>
              </Box>
              <Box>Read your wallet's pulse.</Box>
              <Box
                bgGradient="linear(to-l, #00FFA3, #03E1FF, #DC1FFF)"
                bgClip="text"
              >
                ChainPulseSOL@gmail.com
              </Box>
            </Flex>
          </HStack>
        </Box>
      </Flex>
    </div>
  );
};

export default Footer;
